import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SppdashboardService } from '../dashboard/sppdashboard.service';
import { Validators, FormBuilder } from '@angular/forms';
import { employmentTypeList, namewithSpace } from 'src/app/utils/constants';
import { ToastData, ToastExampleComponent } from 'src/app/component/toast-example/toast-example.component';
import { ToastSuccessComponent } from 'src/app/component/toast-success/toast-success.component';
import { ToastService } from '@pearsonvue/topaz-angular-ui';
import { saveAs } from 'file-saver';
import { UserManagementService } from '../admin/userManagement/user-management.service';
import { EmailChangeConfirmationModalComponent } from 'src/app/component/email-change-confirmation-modal/email-change-confirmation-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../src/environments/env';
import { faCopy } from '@fortawesome/pro-regular-svg-icons';
import { Mtm } from 'src/app/services/mtm';


@Component({
  selector: 'app-mycompany',
  templateUrl: './mycompany.component.html',
  standalone: false,
  styleUrl: './mycompany.component.scss'
})
export class MycompanyComponent implements OnInit {
  data: any;
  public toastService = inject(ToastService<ToastData>);
  public simpleDialog!: MatDialogRef<EmailChangeConfirmationModalComponent>;

  constructor(private _user: UserManagementService, private sppdashboardService: SppdashboardService, private _fb: FormBuilder, private router: Router, private dialogModel: MatDialog, private mtmService: Mtm) { }
  app: any;
  public profileInfo: any;
  public userId: any;
  public validDate: any;
  public timelinedate: any;
  public timeline: any;
  public tempObject: any = {};
  public languageList: any = [];
  public selectedCountry: string = '';
  public selectedRegion: string = '';
  public regionList: any = [];
  public filteredRegion: any = [];
  public countryList: any = [];
  public reminderTimeline: any;
  public renewalDate: any;
  public currentDate: any;
  public endDate: any;
  public startDate: any;
  public regDate: any;
  public downloadingCertificate: boolean = false;
  userHistoryData: any = [];
  public dialogConfig: any = {};
  public status: any;
  isFormSubmitted: boolean = false;
  public url = "Generate link";
  public mtmDetails: any;
  ismtmData: boolean = false;
  enDate: string = sessionStorage.getItem('endDate') || '';

  isCopied: boolean = false;
  icons = {
    faCopy
  }

  handleCopy() {
    this.isCopied = true;
    setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }


  getValidDate(dateValue: any): any {
    if (!dateValue) return null;
    const date = new Date(dateValue);
    return isNaN(date.getTime()) ? null : dateValue;
  }


  public employmentTypeList: any = employmentTypeList;


  ngOnInit() {

    this.dialogConfig = {
      type: 'email change',
      forComponent: 'profile',
      value: '⚠️ Changing your MCT email will remove access to your current Visual Studio subscription, including Azure tenants and M365 apps (Exchange, SharePoint, Teams, and OneDrive Files and Content).We cannot recover any data from your previous account once the change is made.',
      headerTitle: ''
    }

    this.profileInfo = this._fb.group({
      firstname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      lastname: ['', [Validators.required, Validators.pattern(namewithSpace)]],
      mctEnrollmentApprovedDate: [{ value: '', disabled: true }, Validators.required],
      mctSusbcriptionValidUpto: [{ value: '', disabled: true }, Validators.required],
      language: ['', Validators.required],
      country: [{ value: '', disabled: true }, Validators.required],
      region: [{ value: '', disabled: true }, Validators.required],
      employmentType: ['', Validators.required],
      alternateEmail: [''],
      email: [{ value: '', disabled: true }, [Validators.required, Validators.email]],
    });

    this.getLanguageList();
    this.getCountryList();
    this.getRegionList();
    this.currentDate = new Date();

    if (sessionStorage.getItem('timeline') && sessionStorage.getItem('remindertimeline')) {
      this.timeline = sessionStorage.getItem('timeline');
      this.reminderTimeline = sessionStorage.getItem('remindertimeline');

      this.sppdashboardService.getUser().subscribe((response: any) => {
        if (response.success) {
          this.renewalDate = this.getRenewalDate(response.data.mctSubscriptionEndDate, Number(this.reminderTimeline))

          this.userId = response.data.userid;
          this.endDate = response.data.mctSubscriptionEndDate ? new Date(response.data.mctSubscriptionEndDate) : '';
          this.startDate = response.data.mctSubscriptionStartDate ? new Date(response.data.mctSubscriptionStartDate) : '';
          this.regDate = response.data.firstTimeRegDate ? new Date(response.data.firstTimeRegDate) : '';
          this.validDate = new Date(response.data.mctSubscriptionStartDate ? response.data.mctSubscriptionStartDate : '');

          this.validDate.setDate(this.validDate.getDate() + Number(this.timeline));
          this.timelinedate = this.validDate;
          this.getMtmDetails(response?.data?.email);

          const editFirst = {
            firstname: response.data.firstname,
            lastname: response.data.lastname,
            mctEnrollmentApprovedDate: response.data.mctEnrollmentApprovedDate,
            mctSusbcriptionValidUpto: this.timelinedate == 'NaN/NaN/NaN' || response.data.status == 'REJECT' || response.data.status == 'RENEWAL_REJECT' || response.data.status == 'EXPIRED' ? '' : this.timelinedate,
            email: response.data.email,
            language: response.data.language,
            country: response.data.country,
            region: response.data.region,
            employmentType: response.data.employmentType,
            alternateEmail: response.data.alternateEmail
          }

          this.profileInfo.patchValue(editFirst);
          this.getCountryList();
          this.status = response?.data?.status;

          this.onCountryChange({ value: response?.data?.country });
          this.userId && this.fetchuserHistory(this.userId);
        }
      });
    }
  }


  // allowOnlyAlphabets(event: KeyboardEvent): boolean {
  //   const allowedRegex = /^[a-zA-Z\s]$/;
  //   // Allow essential browser navigation keys to function normally
  //   if (event.key === 'Backspace' || event.key === 'Tab' || event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
  //     return true;
  //   }
  //   if (allowedRegex.test(event.key)) {
  //     return true;
  //   }
  //   event.preventDefault();
  //   return false;
  // }

  onCountryChange(event: any) {
    const id = this.countryList?.filter((country: any) => country?.countryName === event?.value)[0]?.id
    if (id) {
      this.sppdashboardService.getRegion(id).subscribe((response: any) => {
        this.filteredRegion.push(response)
        this.selectedCountry = this.filteredRegion[0].countryName
        this.selectedRegion = this.filteredRegion[0].regionName
        this.profileInfo.patchValue({
          region: this.filteredRegion[0].regionName
        });
      })
      this.filteredRegion = [];
    }
  }


  getLanguageList = () => {
    this.sppdashboardService.getLanguageList().subscribe((response: any) => {
      this.languageList = response;
    });
  }

  getCountryList = () => {
    this.sppdashboardService.getCountryList().subscribe((response: any) => {
      this.countryList = response;
    });
  }


  getRegionList = () => {
    this.sppdashboardService.getCountryList().subscribe((response: any) => {
      this.regionList = response.sort();
    });
  }

  getMtmDetails = (email: string) => {
    this.mtmService.getmtmDetails({ email: email }).subscribe((response: any) => {
      if (response.success) {
        this.mtmDetails = response.data;
      }
    });
  }

  submit() {

    this.url = "Generate link";

    this.tempObject = {
      firstname: this.profileInfo.value?.firstname,
      lastname: this.profileInfo.value?.lastname,
      email: this.profileInfo.getRawValue()?.email,
      language: this.profileInfo.value.language,
      country: this.profileInfo.getRawValue()?.country,
      region: this.profileInfo.getRawValue()?.region,
      employmentType: this.profileInfo.value.employmentType,
      alternateEmail: this.profileInfo.value.alternateEmail
    }

    this.profileInfo.markAllAsTouched();
    if (this.profileInfo.valid) {
      this.isFormSubmitted = true;
      this.sppdashboardService.updateProfile(this.tempObject, this.userId).subscribe((response: any) => {
        if (response.success === true) {
          this.isFormSubmitted = false;
        }
      })
    }
  }

  getRenewalDate(dateValue: any, reminderTimeline: any): any {
    if (!dateValue || !reminderTimeline) return null;
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return null;
    // Subtract reminderTimeline days
    date.setDate(date.getDate() - Number(reminderTimeline));
    return date;
  }


  public openCustom() {
    this.toastService.initialize({ enableAutoDismiss: true, autoDismissDelay: 500 })
    this.toastService.open(ToastSuccessComponent, { toastType: 'success', url: this.url });
  }

  generate() {
    if (this.url == 'Generate link') {
      let errorMessage = '';
      if (!this.startDate) {
        errorMessage = "Please provide Start Date";
      } else if (!this.endDate) {
        errorMessage = "Please provide End Date";
      } else if (!this.profileInfo.value?.firstname) {
        errorMessage = "Please provide First Name";
      } else if (!this.profileInfo.value?.lastname) {
        errorMessage = "Please provide Last Name";
      }

      if (errorMessage) {
        this.toastService.open(ToastExampleComponent, {
          toastType: "alert",
          name: errorMessage
        });
        return;
      }
      this.sppdashboardService.generate().subscribe((response: any) => {

        const url = new URL(response.data);
        const mct_user_token = url.searchParams.get("token");

        async function getPublicIP() {
          const response = await fetch('https://api.ipify.org/?format=json');
          const data = await response.json();
          return data.ip;

        }

        getPublicIP().then((ip) => {
          //const url = '/assets/certificate.html?token=' + mct_user_token; 
          this.url = environment.APP_URL + '/assets/certificate.html' + '?token=' + mct_user_token + '&url=' + environment.BASE_URL;
          this.openCustom();
        })

      }, (error: any) => {
        // console.error("Error generating", error);
      });
    }
    else {
      this.toastService.open(ToastSuccessComponent, { toastType: 'success', url: 'copy certificate link' });
    }
  }

  downloadCertificate() {
    let errorMessage = '';
    if (!this.startDate) {
      errorMessage = "Please provide Start Date";
    } else if (!this.endDate) {
      errorMessage = "Please provide End Date";
    } else if (!this.profileInfo.value?.firstname) {
      errorMessage = "Please provide First Name";
    } else if (!this.profileInfo.value?.lastname) {
      errorMessage = "Please provide Last Name";
    }

    if (errorMessage) {
      this.toastService.open(ToastExampleComponent, {
        toastType: "alert",
        name: errorMessage
      });
      return;
    }

    this.downloadingCertificate = true;

    this.sppdashboardService.downloadCertificate().subscribe((response: Blob) => {
      try {
        // Check if blob has content
        if (response.size === 0) {
          return;
        }

        // Create blob with proper PDF MIME type
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        // Sanitize filename to prevent XSS
        const sanitizedFilename = this.sanitizeFilename('MCT Certificate.pdf');

        // Create download link
        const a = document.createElement('a');
        a.href = url;
        //a.download = sanitizedFilename;
        a.style.display = 'none';
        saveAs(blob, sanitizedFilename);
        // Trigger download
        // document.body.appendChild(a);
        // a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        // console.error('Error downloading certificate:', error);
      } finally {
        this.downloadingCertificate = false;
      }
    }, (error: any) => {
      // console.error('API Error downloading certificate:', error);
      this.downloadingCertificate = false;
    });
  }

  /**
   * Sanitizes filename to prevent XSS attacks
   * @param filename - The filename to sanitize
   * @returns Sanitized filename safe for DOM manipulation
   */
  private sanitizeFilename(filename: string): string {
    if (!filename || typeof filename !== 'string') {
      return 'download.pdf'; // Default safe filename
    }

    // Remove potentially dangerous characters and limit to alphanumeric, dots, hyphens, underscores, and spaces
    const sanitized = filename.replace(/[^a-zA-Z0-9.\-_ ]/g, '');

    // Ensure the filename is not empty after sanitization
    if (sanitized.length === 0) {
      return 'download.pdf';
    }

    // Limit length to prevent excessively long filenames
    return sanitized.substring(0, 100);
  }

  fetchuserHistory(id: any): void {
    this._user.fetchuserHistory(id).subscribe((res: any) => {
      this.userHistoryData = res.data;
    });
  }

  onChangeEmailClick() {
    this.simpleDialog = this.dialogModel.open(EmailChangeConfirmationModalComponent, { data: this.dialogConfig });

    this.simpleDialog.afterClosed().subscribe((value) => {
      if (value == 'continue') {
        this.router.navigate(['/emailupdate']);
      }
    });
  }
}
